export default "__VITE_ASSET__p5Rbu9c3__"